import { getBaseUrl } from "../utils";
import { AuthAPI } from "./auth/auth";
import { BillingsAPI } from "./billings/billings";
import { ChangeLogsAPI } from "./change-logs/change-logs";
import { DadataAPI } from "./dadata";
import { InvitationsAPI } from "./invitations/invitations";
import { LocationsAPI } from "./locations/locations";
import { LocksAPI } from "./locks/locks";
import { MeetingRoomsAPI } from "./meetingRooms";
import { NotificationsAPI } from "./notifications/notifications";
import { OfficiesAPI } from "./officies/officies";
import { PrintersAPI } from "./printers/printers";
import { RentersAPI } from "./renters/renters";
import { RequisitesAPI } from "./requisites/requisites";
import { S3API } from "./s3/s3";
import { TempAgreementsAPI } from "./temp-agreements/temp-agreements";
import { TicketsAPI } from "./tickets/tickets";
import { UsersAPI } from "./users/user";
import { DevicesAPI } from "./devices/devices";
import { AccessCardsAPI } from "./accessCards/accessCards";

const baseUrl = getBaseUrl() + "/client";
// const baseUrl = "http://localhost:8100/client";

export const S3_URL =
  "https://a1d91567-6989-4fd0-853c-f63799386a9d.selstorage.ru";

export const api = {
  auth: AuthAPI(baseUrl),
  billings: BillingsAPI(baseUrl),
  locations: LocationsAPI(baseUrl),
  locks: LocksAPI(baseUrl),
  officies: OfficiesAPI(baseUrl),
  renters: RentersAPI(baseUrl),
  users: UsersAPI(baseUrl),
  tickets: TicketsAPI(baseUrl),
  notifications: NotificationsAPI(baseUrl),
  dadata: DadataAPI(baseUrl),
  meetingRooms: MeetingRoomsAPI(baseUrl),
  printers: PrintersAPI(baseUrl),
  requisites: RequisitesAPI(baseUrl),
  tempAgreements: TempAgreementsAPI(baseUrl),
  changeLogs: ChangeLogsAPI(baseUrl),
  s3: S3API(baseUrl),
  invitations: InvitationsAPI(baseUrl),
  devices: DevicesAPI(baseUrl),
  accessCards: AccessCardsAPI(baseUrl),
};
